/* Redesign Icons 24 */
/* 02 */ import ChevronLeftIcon from '@/assets/icons/ChevronLeftIcon.vue';
/* 03 */ import ChevronRightIcon from '@/assets/icons/ChevronRightIcon.vue';
/* 04 */ import CloseIcon from '@/assets/icons/CloseIcon.vue';
/* 05 */ import EyeOpenIcon from '@/assets/icons/EyeOpenIcon.vue';
/* 06 */ import UploadIcon from '@/assets/icons/UploadIcon.vue';
/* 07 */ import CheckOutlineCircleIcon from '@/assets/icons/CheckOutlineCircleIcon.vue';
/* 08 */ import ClockOutlineIcon from '@/assets/icons/ClockOutlineIcon.vue';
/* 09 */ import PaperclipIcon from '@/assets/icons/PaperclipIcon.vue';
/* 10 */ // PlusOutlineIcon with preset color
/* 11 */ import LinkIcon from '@/assets/icons/LinkIcon.vue';
/* 12 */ // PictureIcon
/* 13 */ // RefreshOutlineIcon with preset color
/* 14 */ import EyeCloseIcon from '@/assets/icons/EyeCloseIcon.vue';
/* 15 */ import MixIcon from '@/assets/icons/MixIcon.vue';
/* 16 */ import UserTeamIcon from '@/assets/icons/UserTeamIcon.vue';
/* 17 */ import UserIcon from '@/assets/icons/UserIcon.vue';
/* 18 */ import PencilIcon from '@/assets/icons/PencilIcon.vue';
/* 19 */ import AlertIcon from '@/assets/icons/AlertIcon.vue';
/* 20 */ import ChevronDownIcon from '@/assets/icons/ChevronDownIcon.vue';
/* 21 */ import ChevronUpIcon from '@/assets/icons/ChevronUpIcon.vue';
/* 22 */ import TrashIcon from '@/assets/icons/TrashIcon.vue';
/* 23 */ import CheckIcon from '@/assets/icons/CheckIcon.vue';
/* 24 */ import PictureIcon from '@/assets/icons/PictureIcon.vue';
/* 25 */ import VideoIcon from '@/assets/icons/VideoIcon.vue';
/* 26 */ // FileOutlineIcon
/* 27 */ import WebIcon from '@/assets/icons/WebIcon.vue';
/* 28 */ import ComputerIcon from '@/assets/icons/ComputerIcon.vue';
/* 29 */ import GeoIcon from '@/assets/icons/GeoIcon.vue';
/* 30 */ import TextIcon from '@/assets/icons/TextIcon.vue';
/* 31 */ import GridIcon from '@/assets/icons/GridIcon.vue';
/* 32 */ import ListIcon from '@/assets/icons/ListIcon.vue';
/* 33 */ import SaveIcon from '@/assets/icons/SaveIcon.vue';
/* 34 */ import CopyIcon from '@/assets/icons/CopyIcon.vue';
/* 35 */ import CheckAllIcon from '@/assets/icons/CheckAllIcon.vue';
/* 36 */ import RestoreIcon from '@/assets/icons/RestoreIcon.vue';
/* 37 */ import PaletteIcon from '@/assets/icons/PaletteIcon.vue';
/* 38 */ import InfoIcon from '@/assets/icons/InfoIcon.vue';
/* 39 */ import ChartIcon from '@/assets/icons/ChartIcon.vue';
/* 40 */ import CalendarIcon from '@/assets/icons/CalendarIcon.vue';
/* 41 */ import LikeOutlineIcon from '@/assets/icons/LikeOutlineIcon.vue';
/* 42 */ import BellIcon from '@/assets/icons/BellIcon.vue';
/* 43 */ import ArrowTopIcon from '@/assets/icons/ArrowTopIcon.vue';
/* 44 */ import ArrowTopRightOutlineIcon from '@/assets/icons/ArrowTopRightOutlineIcon.vue';
/* 45 */ import PlusOutlineIcon from '@/assets/icons/PlusOutlineIcon.vue';
/* 46 */ import RefreshOutlineIcon from '@/assets/icons/RefreshOutlineIcon.vue';
/* 47 */ import SettingIcon from '@/assets/icons/SettingIcon.vue';
/* 48 */ import ArrowLeftIcon from '@/assets/icons/ArrowLeftIcon.vue';
/* 49 */ import StarOutlineIcon from '@/assets/icons/StarOutlineIcon.vue';
/* 50 */ import StarIcon from '@/assets/icons/StarIcon.vue';
/* 51 */ import EditIcon from '@/assets/icons/EditIcon.vue';
/* 52 */ import StarOutlineCircleIcon from '@/assets/icons/StarOutlineCircleIcon.vue';
/* 53 */ import FolderAddOutlineIcon from '@/assets/icons/FolderAddOutlineIcon.vue';
/* 54 */ import FileOutlineIcon from '@/assets/icons/FileOutlineIcon.vue';
/* 55 */ import DotsHorizontalIcon from '@/assets/icons/DotsHorizontalIcon.vue';
/* 56 */ import ZoomIcon from '@/assets/icons/ZoomIcon.vue';
/* 57 */ import RoubleOutlineIcon from '@/assets/icons/RoubleOutlineIcon.vue';
/* 58 */ import UnionIcon from '@/assets/icons/UnionIcon.vue';
/* 59 */ import DownloadIcon from '@/assets/icons/DownloadIcon.vue';

/* Redesign Icons 40 */
/* 04 */ import QuestionOutlineCircleIcon from '@/assets/icons/QuestionOutlineCircleIcon.vue';

/* Redesign Icons 48 */
/* 01 */ import CloseOutlineCircleIcon from '@/assets/icons/CloseOutlineCircleIcon.vue';
/* 02 */ import UploadCloudIcon from '@/assets/icons/UploadCloudIcon.vue';

/* Old Redesign Icons 24 */
/* 06 */ import ExitIcon from '@/assets/icons/ExitIcon.vue';
/* 09 */ import BellOutlineIcon from '@/assets/icons/BellOutlineIcon.vue';
/* 11 */ import OptionsIcon from '@/assets/icons/OptionsIcon.vue';
/* 15 */ import ArrowTopRightIcon from '@/assets/icons/ArrowTopRightIcon.vue';
/* 26 */ import MailIcon from '@/assets/icons/MailIcon.vue';
/* 27 */ import Crown1Icon from '@/assets/icons/Crown1Icon.vue';
/* 29 */ import Crown2Icon from '@/assets/icons/Crown2Icon.vue';
/* 30 */ import Crown3Icon from '@/assets/icons/Crown3Icon.vue';
/* 31 */ import Crown4Icon from '@/assets/icons/Crown4Icon.vue';
/* 32 */ import BellOutlineActiveIcon from '@/assets/icons/BellOutlineActiveIcon.vue';
/* 36 */ import MenuIcon from '@/assets/icons/MenuIcon.vue';

/* Old Redesign Icons 32 */
/* 10 */ import LightingIcon from '@/assets/icons/LightingIcon.vue';

/* Additional Icons */
import LikeIcon from '@/assets/icons/LikeIcon.vue';
import FolderIcon from '@/components/icons/FolderIcon.vue';
import FolderFavoriteIcon from '@/assets/icons/FolderFavoriteIcon.vue';
import FolderFavoriteOutlineIcon from '@/assets/icons/FolderFavoriteOutlineIcon.vue';
import PhoneCallIcon from '@/assets/icons/PhoneCallIcon.vue';
import PlusIcon from '@/assets/icons/PlusIcon.vue';
import FilePdfIcon from '@/assets/icons/FilePdfIcon.vue';
import FileDocIcon from '@/assets/icons/FileDocIcon.vue';
import FileIcon from '@/assets/icons/FileIcon.vue';
import Award1Icon from '@/assets/icons/Award1Icon.vue';
import Award2Icon from '@/assets/icons/Award2Icon.vue';
import Award3Icon from '@/assets/icons/Award3Icon.vue';
import AwardPIcon from '@/assets/icons/AwardPIcon.vue';
import DotOutlineIcon from '@/assets/icons/DotOutlineIcon.vue';
import Medal1Icon from '@/assets/icons/Medal1Icon.vue';
import Medal2Icon from '@/assets/icons/Medal2Icon.vue';
import Medal3Icon from '@/assets/icons/Medal3Icon.vue';

/* UI Controls Icons */
import CheckboxOffIcon from '@/assets/icons/CheckboxOffIcon.vue';
import CheckboxOnIcon from '@/assets/icons/CheckboxOnIcon.vue';
import RadioOffIcon from '@/assets/icons/RadioOffIcon.vue';
import RadioOnIcon from '@/assets/icons/RadioOnIcon.vue';

/* External Icons */
import GooglePlayStoreIcon from '@/components/icons/GooglePlayStoreIcon.vue';
import VkIcon from '@/components/icons/VkIcon.vue';
import Telegram from '@/assets/icons/telegram.vue';
import TelegramMini from '@/assets/icons/telegram-mini.vue';
import Vk from '@/assets/icons/vk.vue';
import TelegramIcon from '@/assets/icons/TelegramIcon.vue';
import Android from '@/assets/icons/Android.vue';
import AppleAppStore from '@/assets/icons/AppleAppStore.vue';
import GooglePlay from '@/assets/icons/GooglePlay.vue';
import RuStore from '@/assets/icons/RuStore.vue';

export default {
  /* Redesign Icons 24 */
  'ichevron-left': {
    component: ChevronLeftIcon,
  },
  'ichevron-right': {
    component: ChevronRightIcon,
  },
  iclose: {
    component: CloseIcon,
  },
  'ieye-open': {
    component: EyeOpenIcon,
  },
  iupload: {
    component: UploadIcon,
  },
  'icheck-outline-circle': {
    component: CheckOutlineCircleIcon,
  },
  'iclock-outline': {
    component: ClockOutlineIcon,
  },
  ipaperclip: {
    component: PaperclipIcon,
  },
  /* 10-45 */ // i-plus-outline with preset color
  ilink: {
    component: LinkIcon,
  },
  /* 12-24 */ // i-picture
  /* 13-46 */ // i-refresh-outline with preset color
  'ieye-close': {
    component: EyeCloseIcon,
  },
  imix: {
    component: MixIcon,
  },
  'iuser-team': {
    component: UserTeamIcon,
  },
  iuser: {
    component: UserIcon,
  },
  ipencil: {
    component: PencilIcon,
  },
  ialert: {
    component: AlertIcon,
  },
  'ichevron-down': {
    component: ChevronDownIcon,
  },
  'ichevron-up': {
    component: ChevronUpIcon,
  },
  itrash: {
    component: TrashIcon,
  },
  icheck: {
    component: CheckIcon,
  },
  ipicture: {
    component: PictureIcon,
  },
  ivideo: {
    component: VideoIcon,
  },
  /* 26-54 */ // i-file-outline
  iweb: {
    component: WebIcon,
  },
  icomputer: {
    component: ComputerIcon,
  },
  igeo: {
    component: GeoIcon,
  },
  itext: {
    component: TextIcon,
  },
  igrid: {
    component: GridIcon,
  },
  ilist: {
    component: ListIcon,
  },
  isave: {
    component: SaveIcon,
  },
  icopy: {
    component: CopyIcon,
  },
  'icheck-all': {
    component: CheckAllIcon,
  },
  irestore: {
    component: RestoreIcon,
  },
  ipalette: {
    component: PaletteIcon,
  },
  iinfo: {
    component: InfoIcon,
  },
  ichart: {
    component: ChartIcon,
  },
  icalendar: {
    component: CalendarIcon,
  },
  'ilike-outline': {
    component: LikeOutlineIcon,
  },
  ibell: {
    component: BellIcon,
  },
  'iarrow-top': {
    component: ArrowTopIcon,
  },
  'iarrow-top-right-outline': {
    component: ArrowTopRightOutlineIcon,
  },
  'iplus-outline': {
    component: PlusOutlineIcon,
  },
  'irefresh-outline': {
    component: RefreshOutlineIcon,
  },
  isettings: {
    component: SettingIcon,
  },
  'iarrow-left': {
    component: ArrowLeftIcon,
  },
  'istar-outline': {
    component: StarOutlineIcon,
  },
  istar: {
    component: StarIcon,
  },
  iedit: {
    component: EditIcon,
  },
  'istar-outline-circle': {
    component: StarOutlineCircleIcon,
  },
  'ifolder-add-outline': {
    component: FolderAddOutlineIcon,
  },
  'ifile-outline': {
    component: FileOutlineIcon,
  },
  'idots-horizontal': {
    component: DotsHorizontalIcon,
  },
  'idot-outline': {
    component: DotOutlineIcon,
  },
  izoom: {
    component: ZoomIcon,
  },
  'irouble-outline': {
    component: RoubleOutlineIcon,
  },
  iunion: {
    component: UnionIcon,
  },
  idownload: {
    component: DownloadIcon,
  },

  /* Redesign Icons 40 */
  'iquestion-outline-circle': {
    component: QuestionOutlineCircleIcon,
  },

  /* Redesign Icons 48 */
  'iclose-outline-circle': {
    component: CloseOutlineCircleIcon,
  },
  'iupload-cloud': {
    component: UploadCloudIcon,
  },

  /* Old Redesign Icons 24 */
  iexit: {
    component: ExitIcon,
  },
  'ibell-outline': {
    component: BellOutlineIcon,
  },
  ioptions: {
    component: OptionsIcon,
  },
  'iarrow-top-right': {
    component: ArrowTopRightIcon,
  },
  imail: {
    component: MailIcon,
  },
  'icrown-4': {
    component: Crown1Icon,
  },
  'icrown-3': {
    component: Crown2Icon,
  },
  'icrown-2': {
    component: Crown3Icon,
  },
  'icrown-1': {
    component: Crown4Icon,
  },
  'ibell-outline-active': {
    component: BellOutlineActiveIcon,
  },
  imenu: {
    component: MenuIcon,
  },

  /* Old Redesign Icons 32 */
  ilighting: {
    component: LightingIcon,
  },

  /* Additional Icons */
  ilike: {
    component: LikeIcon,
  },
  ifolder: {
    component: FolderIcon,
  },
  'ifolder-favorite': {
    component: FolderFavoriteIcon,
  },
  'ifolder-favorite-outline': {
    component: FolderFavoriteOutlineIcon,
  },
  'iphone-call': {
    component: PhoneCallIcon,
  },
  iplus: {
    component: PlusIcon,
  },
  'ifile-pdf': {
    component: FilePdfIcon,
  },
  'ifile-doc': {
    component: FileDocIcon,
  },
  ifile: {
    component: FileIcon,
  },
  'iaward-1': {
    component: Award1Icon,
  },
  'iaward-2': {
    component: Award2Icon,
  },
  'iaward-3': {
    component: Award3Icon,
  },
  'iaward-p': {
    component: AwardPIcon,
  },
  'imedal-1': {
    component: Medal1Icon,
  },
  'imedal-2': {
    component: Medal2Icon,
  },
  'imedal-3': {
    component: Medal3Icon,
  },

  /* UI Controls Icons */
  'icheckbox-off': {
    component: CheckboxOffIcon,
  },
  'icheckbox-on': {
    component: CheckboxOnIcon,
  },
  'iradio-on': {
    component: RadioOnIcon,
  },
  'iradio-off': {
    component: RadioOffIcon,
  },

  /* External Icons */
  googlePlayStore: {
    component: GooglePlayStoreIcon,
  },
  itelegram: {
    component: Telegram,
  },
  'i-telegram-mini': {
    component: TelegramMini,
  },
  ivk: {
    component: Vk,
  },
  vk: {
    component: VkIcon,
  },
  'i-telegram': {
    component: TelegramIcon,
  },
  iandroid: {
    component: Android,
  },
  'iapple-app-store': {
    component: AppleAppStore,
  },
  'igoogle-play': {
    component: GooglePlay,
  },
  'iru-store': {
    component: RuStore,
  },
};
